import React from 'react';
import { Dimensions, StyleSheet, Text, View } from 'react-native';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import { FONT_STYLES, textStyles } from '../../../../constants/textStyles';
import { RandomStars, Star } from '../../../helperComponents/RandomStars';
import { AnimatedView, seconds } from '../../../../utils/animations';
import CoinIcon from '../../../../resources/svgComponents/Quarter/CoinIcon';
import QuestionIcon from '../../../../resources/svgComponents/QuestionIcon';

function getStarAnimation(star: Star) {
    return {
        0: {
            top: star.y,
            left: star.x,
        },
        0.4: {
            top: star.toY,
            left: star.toX,
        },
        0.8: {
            top: star.toY,
            left: star.toX,
        },
        1: {
            top: star.y,
            left: star.x,
        },
    };
}

const coinAnimation = {
    0: {
        // rotateY: '0deg',
        transform: [{ rotateY: '0deg' }],
    },
    0.25: {
        // rotateY: '360deg',
        transform: [{ rotateY: '360deg' }],
    },
    0.5: {
        // rotateY: '360deg',
        transform: [{ rotateY: '360deg' }],
    },
    0.75: {
        // rotateY: '0deg',
        transform: [{ rotateY: '0deg' }],
    },
    1: {
        // rotateY: '0deg',
        transform: [{ rotateY: '0deg' }],
    },
};

type StepOverlayProps = {
    step: 'guess' | 'bet' | 'bonus';
};

export function StepOverlay({ step }: StepOverlayProps) {
    const { width, height } = Dimensions.get('window');
    const rightSpace = step === 'guess' || step === 'bonus' ? 12 : 0;
    const topSpace = step === 'bet' ? 12 : 0;
    return (
        <AnimatedView
            pointerEvents="none"
            fromOpacity={1}
            toOpacity={0}
            delay={seconds(step === 'bet' ? 3 : 2)}
            style={[styles.container, { backgroundColor: colors[step] }]}
        >
            <RandomStars
                numberOfStars={20}
                width={width}
                height={step === 'guess' ? height - 100 : height}
                minSize={15}
                maxSize={40}
                numberOfRows={6}
                numberOfColumns={4}
                getAnimation={getStarAnimation}
                duration={seconds(step === 'bet' ? 3 : 2)}
                enabled
            />
            <View style={styles.content}>
                {step === 'bet' && (
                    <AnimatedView
                        animation={coinAnimation}
                        duration={seconds(2)}
                        delay={seconds(1)}
                        easing="linear"
                    >
                        <CoinIcon size={80} />
                    </AnimatedView>
                )}
                <View style={[styles.subContent, { marginTop: topSpace }]}>
                    <Text
                        style={[styles.titleText, { marginRight: rightSpace }]}
                    >
                        {step === 'guess' && 'GUESS'}
                        {step === 'bet' && 'BET'}
                        {step === 'bonus' && 'BONUS'}
                    </Text>
                    {step === 'guess' && <QuestionIcon />}
                    {step === 'bonus' && <CoinIcon size={44} />}
                </View>
            </View>
            {/* {step === 'guess' && (
                <View style={styles.note}>
                    <ShadowView
                        style={styles.noteContainer}
                        topLeftShadowColor="#038BBF"
                        bottomRightShadowColor="#0682B18C"
                    >
                        <View style={styles.noteHeader}>
                            <CoinsIcon size={30} />
                            <Text style={styles.pointText}>50</Text>
                        </View>
                        <Text style={styles.messageText}>
                            You’ve got 50 points to start! Answer questions
                            correctly to earn more.
                        </Text>
                    </ShadowView>
                </View>
            )} */}
        </AnimatedView>
    );
}

const colors: Record<StepOverlayProps['step'], string> = {
    guess: '#0295CD',
    bet: '#6A2C8C',
    bonus: '#FCAF41',
};

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        backgroundColor: '#0295CD',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        zIndex: 100,
    },
    content: {
        alignItems: 'center',
    },
    subContent: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    titleText: mbTextStyles([
        textStyles.normalText,
        {
            fontFamily: FONT_STYLES.Tabasco_400,
            fontWeight: '400',
            color: '#FFFFFF',
            fontSize: 55,
        },
    ]),
    note: {
        position: 'absolute',
        bottom: 50,
        width: '85%',
    },
    noteContainer: {
        backgroundColor: '#0295CD',
        padding: 20,
    },
    noteHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    pointText: mbTextStyles([
        textStyles.normalText,
        {
            fontFamily: FONT_STYLES.Tabasco_400,
            fontWeight: '400',
            color: '#FFFFFF',
            fontSize: 29,
            marginLeft: 8,
        },
    ]),
    messageText: mbTextStyles([
        textStyles.normalText,
        {
            color: '#FFFFFF',
            marginTop: 19,
        },
    ]),
});
